var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 default"},[_c('div',{staticClass:"col-xl-12 xeEnergyCostAnalysis"},[_c('header-box',{attrs:{"title":`${_vm.$t('운영 기준정보 관리')} > ${_vm.$t(
        '사용자 정의 관제점 설정'
      )}`}}),_c('div',{staticClass:"searchArea row"},[_c('div',{staticClass:"col-md-12 innerBox"},[_c('search-box',{ref:'searchBox',on:{"search:data":_vm.onSearch}})],1)]),_c('grid-box',{ref:'gridBox',on:{"reSearch":_vm.reSearch}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }